<template>
  <div class="department-business-add">
    <el-card class="box-card m-b">
      <top-form :disabled="disabled" ref="topForm" :defaultData="baseData" :userInfo="userInfo" />
    </el-card>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('departmentBusinessAdd.businessTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <business-form
            :disabled="disabled"
            ref="businessForm"
            @storageChange="storageChange"
            @saleDepartmentChange="saleDepartmentChange"
            :defaultData="baseData"
            :userInfo="userInfo"
          ></business-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <el-tab-pane name="first" :label="$t('departmentBusinessAdd.productTitle')">
            <product-table
              :isEdit="isEdit"
              ref="productTable"
              :saleStorageCode="saleStorage.saleStorageCode"
              :saleDepartmentCode="saleDepartmentCode"
              :defaultData="defaultProduct"
            ></product-table>
          </el-tab-pane>
          <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--TODO 根据不同状态展示不同按钮-->
      <el-button
        v-if="isEdit"
        :loading="load"
        @click="handleSave"
        v-hasPermi="['2021050814110298958']"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-if="isEdit"
        type="primary"
        :loading="load"
        @click="handleSubmit"
        v-hasPermi="['2021050814112087202']"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.approval') }}</el-button
      >
      <el-button
        v-if="isEdit && (baseData.tradeStatus == 'ZT06' || baseData.tradeStatus == 'ZT01')"
        type="danger"
        :loading="load"
        class="fixed-bottom-btn"
        @click="handleDelete"
        v-hasPermi="['2021050814103655071']"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <el-button
        v-if="baseData.tradeStatus == 'ZT07'"
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        @click="doConfirm"
        >{{ this.$t('functionBtn.confirm') }}</el-button
      >
      <el-button
        v-if="
          baseData.tradeStatus == 'ZT03' &&
          ['notgenerate', 'generated', 'postError'].indexOf(baseData.accountingStatus) != -1
        "
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        @click="handleAccountEntry"
        >{{ $t('addInvoice.btns.accountEntry') }}</el-button
      >
      <el-button
        v-if="
          baseData.tradeStatus == 'ZT03' &&
          ['generated', 'postError'].indexOf(baseData.accountingStatus) != -1
        "
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        @click="doSyncVoucherForEntityData()"
        >{{ $t('functionBtn.doSyncVoucher') }}</el-button
      >
      <el-button
        v-if="baseData.tradeStatus == 'ZT07'"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >撤回</el-button
      >
      <el-button
        v-if="baseData.tradeStatus == 'ZT03'"
        type="primary"
        @click="doReverseAccountEntry"
        v-hasPermi="['2021050814113161301']"
        :loading="load"
        class="fixed-bottom-btn"
        >冲销</el-button
      >
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import topForm from './components/top-form';
  import businessForm from './components/business-form';
  // import financeForm from './components/finance-form';
  import productTable from './components/product-table';
  import API from '@/api/departmentBusiness/index';
  import voucherMixins from '@/common/mixins/voucher.js';

  export default {
    mixins: [voucherMixins],
    components: {
      topForm,
      businessForm,
      // financeForm,
      productTable,
    },
    data() {
      return {
        load: false,
        activeNames: ['1', '2', '3', '4'], //默认展开那些面板，
        baseData: {},
        financeData: {},
        defaultProduct: [],
        disabled: true,
        isEdit: false,
        saleStorage: {
          saleStorageCode: '', // 卖出仓库
          saleStorageName: '', // 卖出仓库
        },
        saleDepartmentCode: '', //卖出部门
        saleDepartmentName: '',

        voucherFlag: 'AE_PO_CST_ADJUSTMENT', //凭证标识
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 确认
      doConfirmInfo(info) {
        let params = {
          id: this.baseData.id,
          tradeNo: this.baseData.tradeNo,
          ...info,
        };
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getData();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      getData() {
        const query = this.$route.query;
        const name = this.$route.name;
        // 编辑、详情获取数据
        if (name == 'departmentBusinessAdd') {
          this.disabled = false;
          this.isEdit = true;
          this.saleDepartmentCode = this.userInfo.departmentCode;
        } else {
          // 查询详情，根据状态给出是否可编辑
          const { tradeNo } = query;
          if (tradeNo) {
            // 请求详情
            this.$axios.post(API.GET_TRADE, { tradeNo }).then((res) => {
              if (res.data.code === 0) {
                const data = res.data.data;
                const editStatus = ['ZT06', 'ZT05', 'ZT01']; // 草稿、已驳回 可以修改  新增交易失败
                if (editStatus.indexOf(data.tradeStatus) > -1) {
                  this.isEdit = true;
                  this.disabled = false;
                }
                const baseData = Object.assign({}, data);
                delete baseData.tradeFinance;
                delete baseData.tradeDetails;
                this.baseData = baseData;
                this.saleStorage = {
                  saleStorageCode: baseData.saleStorageCode,
                  saleStorageName: baseData.saleStorageName,
                };
                this.saleDepartmentCode = this.baseData.saleDepartmentCode;
                this.defaultProduct = data.tradeDetails || [];
                // 获取凭证ID 获取凭证列表
                this.entityDataId = data.id;
                this.getAccountEntry();
              }
            });
          }
        }
      },
      storageChange(saleStorageCode, saleStorageName) {
        // 卖出仓库不一样，并且商品行项目不为空进行提示
        if (saleStorageCode != this.saleStorage.saleStorageCode) {
          const productData = this.$refs.productTable.getValues();
          if (productData.length > 0) {
            this.$confirmAction(
              this.$t('departmentBusinessAdd.changeStorageTitle'),
              this.$t('departmentBusinessAdd.changeStorageContent')
            )
              .then(() => {
                // 确认选择这个仓库：清空商品行数据
                this.saleStorage = {
                  saleStorageCode,
                  saleStorageName,
                };
                this.$refs.productTable.productData = [];
              })
              .catch(() => {
                // 恢复之前仓库
                this.$refs.businessForm.setSaleStorage(this.saleStorage);
              });
          } else {
            this.saleStorage = {
              saleStorageCode,
              saleStorageName,
            };
          }
        }
      },
      saleDepartmentChange(saleDepartmentCode, saleDepartmentName) {
        // 卖出仓库不一样，并且商品行项目不为空进行提示
        if (saleDepartmentCode != this.saleDepartmentCode) {
          const productData = this.$refs.productTable.getValues();
          if (productData.length > 0) {
            this.$confirmAction(
              this.$t('departmentBusinessAdd.changeDepartmentTitle'),
              this.$t('departmentBusinessAdd.changeStorageContent')
            )
              .then(() => {
                // 确认选择这个部门：清空商品行数据
                this.saleDepartmentCode = saleDepartmentCode;
                this.saleDepartmentName = saleDepartmentName;
                this.$refs.productTable.productData = [];
              })
              .catch(() => {
                // 恢复之前仓库
                this.$refs.businessForm.setSaleStorage({
                  saleDepartmentCode: this.saleDepartmentCode,
                  saleDepartmentName: this.saleDepartmentName,
                });
              });
          } else {
            this.saleDepartmentCode = saleDepartmentCode;
            this.saleDepartmentName = saleDepartmentName;
          }
        }
      },
      handleSave() {
        this.handlePost(0);
      },
      handleSubmit() {
        this.validateForm();
      },
      handleDelete() {
        this.$confirmAction()
          .then(() => {
            const { tradeNo, version } = this.baseData;
            if (tradeNo) {
              const params = { tradeNo, version };
              this.$axios.post(API.DELETE_TRADE, params).then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.toList();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            }
          })
          .catch(() => {});
      },
      validateForm() {
        const top = this.$refs.topForm.handleSubmit();
        const business = this.$refs.businessForm.handleSubmit();
        // const finance = this.$refs.financeForm.handleSubmit();
        const product = new Promise((resolve) => {
          this.$refs['productTable'].$refs['ruleTable'].validate((valid) => {
            if (valid) resolve();
          });
        });
        Promise.all([top, business, product]).then(() => {
          this.handlePost(1);
        });
      },
      handlePost(type) {
        this.loading.startLoading();
        // 获取表单数据，TODO 表格数据
        const topData = this.$refs.topForm.getValues();
        const businessData = this.$refs.businessForm.getValues();
        // const financeData = this.$refs.financeForm.getValues();
        // 商品表格数据
        const productData = this.$refs.productTable.getValues();
        const tradeDetailDelIds = this.$refs.productTable.tradeDetailDelIds;
        const params = Object.assign(
          {
            type,
          },
          topData,
          businessData,
          {
            tradeDetails: productData,
            tradeDetailDelIds,
          }
        );
        let url = type == 0 ? API.SAVE_TRADE : API.SUBMT_TRADE;
        this.$axios
          .post(url, params)
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              if (type == 0) {
                if (this.$route.name == 'departmentBusinessAdd') {
                  this.dblclickEvent(res.data.data);
                } else {
                  this.getData();
                }
              } else {
                this.toList();
              }
            } else {
              if (type == 1) {
                if (res.data.data) {
                  if (this.$route.name == 'departmentBusinessAdd') {
                    this.dblclickEvent(res.data.data);
                  } else {
                    this.getData();
                  }
                }
              }
              this.$alert(res.data.msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
          });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/departmentBusiness/add',
            name: 'departmentBusinessAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/departmentBusiness/edit',
            name: 'departmentBusinessEdit',
            meta: {
              keepAlive: false,
            },
            query: { tradeNo: value.tradeNo },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 撤回
      async doWithdraw() {
        let params = {
          //撤回所需参数
          idList: [this.baseData.id],
        };
        this.$baseRequest
          .doWithdrawCommon(API.DO_WITHDRAW, params)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: res.msg,
              });
              this.getData();
            } else {
              this.$message({ showClose: true, type: 'error', message: res.msg });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      },
      // 返回列表页
      toList() {
        const name = this.$route.name;
        let path = {
          fromPath: {
            path:
              name === 'departmentBusinessAdd'
                ? '/departmentBusiness/add'
                : '/departmentBusiness/edit',
            name:
              name === 'departmentBusinessAdd' ? 'departmentBusinessAdd' : 'departmentBusinessEdit',
            meta: {
              keepAlive: true,
              title: name === 'departmentBusinessAdd' ? '新建部门间交易' : '编辑部门间交易',
            },
          },
          toPath: {
            path: '/departmentBusiness/list',
            name: 'departmentBusinessList',
            meta: {
              keepAlive: false,
              title: '部门间交易列表',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .box-card {
    padding-top: 15px;
  }
</style>
